import clsx from 'clsx'

import useEnumValues from 'app/hooks/useEnumValues'
import {
    ContainerStatus as ContainerStatusEnum,
    ServiceProcess,
} from 'app/enums/label.enums'

import useStyles from './ContainerStatus.styles'

const CombinedContainerStatuses = {
    ...ContainerStatusEnum,
    ...ServiceProcess,
}

const ContainerStatus = ({
    value,
}: {
    value: string
}) => {
    const {
        classes,
    } = useStyles()
    const containerStatuses = useEnumValues()(CombinedContainerStatuses)

    return (
        <div className={classes.wrapper}>
            <div
                className={clsx(classes.containerStatus, classes.noWrap)}
                title={containerStatuses[value]}
            >
                {containerStatuses[value]}
            </div>
        </div>
    )
}

export default ContainerStatus
